module.exports = __webpack_public_path__ + "static/media/b2b-image-alibaba.526ad362.png";